import { Pipe, PipeTransform } from '@angular/core';
import { formatDecimalSeparator } from '@coin/shared/core/util-helpers';

@Pipe({
  name: 'decimalSeparator',
  standalone: true
})
export class DecimalSeparatorPipe implements PipeTransform {
  transform(value: string, separator: ',' | '.' = '.', showThousandSeparator = false): string {
    return formatDecimalSeparator(value, separator, showThousandSeparator);
  }
}
